import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#F97316]/20 py-10 px-4" data-id="element-227">
      <div className="max-w-3xl mx-auto text-center" data-id="element-228">
        <div className="text-[#F97316] text-2xl font-black tracking-widest mb-4" data-id="element-229">
          🏀 PROFEPACK™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-230">
          El sistema de entrenamientos N°1 para entrenadores de básquet en
          Argentina.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-231">
          Porque entrenar básquet no debería costarte todas las noches de la
          semana.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-232">
          <span data-id="element-233">📧 soporteprofepack@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-234">•</span>
          <span data-id="element-235">📲 @profepack</span>
          <span className="hidden sm:inline" data-id="element-236">•</span>
          <span data-id="element-237">🌐 profepack.com/</span>
        </div>

        <div className="h-px bg-[#F97316]/20 mb-6" data-id="element-238" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-239">
          © ProfePack™ 2026 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-240">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}